<div class="page">
  @if (canView) {
    <mat-tab-group disableRipple class="manage-user-list dialog-table" #tabGroup mat-stretch-tabs="false">
      <mat-tab label="Groups">
        <ng-template matTabContent>
          <div class='user-list-groups-tab'>
            <group-list></group-list>
          </div>
        </ng-template>
      </mat-tab>
      @for (tab of tabs; track tab) {
        <mat-tab [label]="tab | upperfirst | removeUnderscore">
          <user-list [dataSource]="dataSource[tab]"
            [user_meta_dict]="user_meta_dict"
            [can_edit]="canEdit"
            [filterValue]="filterValue"
            (onUserChanged)="userChanged($event)"
            (onSort)="applySort($event)"
            (onFilter)="applyFilter($event)">
          </user-list>
        </mat-tab>
      }
      <mat-tab label="Audit History">
        <ng-template matTabContent>
          <history-table [resourceList]="resource_list"></history-table>
        </ng-template>
      </mat-tab>
    </mat-tab-group>
  } @else {
    You do not have permission to view this page.
  }
</div>
